exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".snackbar[data-v-6978e282]{font-size:20px}.uj-ugyfel-btn[data-v-6978e282]{margin-right:20px;margin-top:3px;color:var(--v-secondaryButtonTextColor-base)}", ""]);

// exports
